/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectHeader_psProject = {
    readonly name: string | null;
    readonly psProgram: {
        readonly id: string;
        readonly name: string | null;
        readonly color: string | null;
        readonly prefix: string | null;
        readonly isViewerProgramMember: boolean | null;
    } | null;
    readonly " $refType": "ProjectHeader_psProject";
};
export type ProjectHeader_psProject$data = ProjectHeader_psProject;
export type ProjectHeader_psProject$key = {
    readonly " $data"?: ProjectHeader_psProject$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectHeader_psProject">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectHeader_psProject",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProgramType",
      "kind": "LinkedField",
      "name": "psProgram",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isViewerProgramMember",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectServiceProjectType"
};
})();
(node as any).hash = '94bf9c398a5600571303acdc8d6f62a8';
export default node;
